export default "__VITE_ASSET__DXC38BQL__"